import { Injectable } from '@angular/core'
import { $app } from '@app/app.service'
import { AppBasicService } from '@data/service/app-basic.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class EventService extends AppBasicService {
   getAll(): Observable<any> {
      const projectId = $app.getCurrentProjectId()

      if (!projectId) return

      return this.http.get(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars`, this.httpOptions).pipe(
         map((res: any) => {
            return res?.map((row) => this.dataSrv.mapEvent(row)) ?? {}
         })
      )
   }

   find(data: any): Observable<any> {
      const projectId = $app.getCurrentProjectId()

      if (!projectId) return

      let queryString = ''
      if (data) {
         queryString += '?start=' + (data.hasOwnProperty('start') ? data['start'] : '')
         queryString += '&end=' + (data.hasOwnProperty('end') ? data['end'] : '')
      }

      return this.http.get(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars${queryString}`, this.httpOptions).pipe(
         map((res: any) => {
            return res?.map((row) => this.dataSrv.mapEvent(row)) ?? {}
         })
      )
   }

   getById(id: any): Observable<any> {
      const projectId = $app.getCurrentProjectId()

      if (!projectId) return

      return this.http.get(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars/${id}`, this.httpOptions).pipe(
         map((res: any) => {
            return this.dataSrv.mapEvent(res, 'detail')
         })
      )
   }

   insert(data: any): Observable<any> {
      if (data) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         let params = data

         return this.http.post<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars`, params, this.httpOptions)
      }

      return of(false)
   }

   update(id: any, data: any): Observable<any> {
      if (data) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         let params = data

         return this.http.put<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars/${id}`, params, this.httpOptions)
      }

      return of(false)
   }

   delete(id: any): Observable<any> {
      if (id != null) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         return this.http.delete<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}/calendars/${id}`, this.httpOptions)
      }

      return of(false)
   }
}

